import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';
import { environment } from '../../../../environments/environment';
import {
  GetDeliveryApprovalsParams,
  ApprovalService,
} from 'netsocial-posting/src/app/services/approval/approval.service';
import { ErrorService } from 'netsocial-posting/src/app/services/error/error.service';
import { observable } from 'mobx-angular';
import { Router } from '@angular/router';
import { from, Subscription } from 'rxjs';
import { ApiRequestService } from 'netsocial-lib/src/app/services/api-request/api-request.service';

@Component({
  selector: 'pending-posts-manager',
  templateUrl: './pending-posts-manager.component.html',
  styleUrls: ['./pending-posts-manager.component.scss'],
})
export class PendingPostsManagerComponent implements OnInit, OnDestroy {
  @observable pendingPostCount?: number;

  private contextSubscription: Subscription;

  constructor(
    private userService: UserService,
    private errorService: ErrorService,
    private approvalService: ApprovalService,
    private router: Router,
    private apiRequest: ApiRequestService
  ) {}

  ngOnInit() {
    this.contextSubscription = this.apiRequest.getContextOwner().subscribe(() => {
      this.getDeliveryApprovals();
    });
  }

  ngOnDestroy() {
    this.contextSubscription.unsubscribe();
  }

  public approveAll() {
    return this.errorService.resolve(
      this.approvalService.setDeliveryApprovals({
        allForTeamMember: this.userService.currentUser?.id,
        action: 'approve',
      })
    );
  }

  public viewPending() {
    return this.router.navigate(['/workspace/queue/pending']);
  }

  private async getDeliveryApprovals(first = 0) {
    this.pendingPostCount = undefined;
    const body: GetDeliveryApprovalsParams = {
      returnedTimezone: this.userService.currentUser?.timezone,
      status: ['pending'],
      perPage: environment.perPage,
      first,
    };

    from(
      this.errorService.resolve(this.approvalService.getDeliveryApprovals(body), {
        errorMessage: 'components.postList.errors.getPosts',
      })
    ).subscribe((deliveryApprovals) => {
      this.pendingPostCount = Number(deliveryApprovals?.paging.count);
    });
  }
}
